import { render, staticRenderFns } from "./MsuAccess.vue?vue&type=template&id=503534e2&scoped=true"
import script from "./MsuAccess.vue?vue&type=script&lang=js"
export * from "./MsuAccess.vue?vue&type=script&lang=js"
import style0 from "./MsuAccess.vue?vue&type=style&index=0&id=503534e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503534e2",
  null
  
)

export default component.exports